import {ITheme} from 'contexts/ThemeContext';
import {useWindowDimensions, ViewStyle} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

export default ({colors, typography}: ITheme) => {
  const {width, height} = useWindowDimensions();

  return {
    containerStyle: {},
    defaultPickerContainerStyle: (isOpen: boolean) => ({
      justifyContent: 'center',
      alignItems: 'center',
      width: 82,
      height: 48,
      backgroundColor: colors.white,
      borderRadius: 8,
      borderWidth: 1,
      borderColor: isOpen ? colors.cornflowerBlue : colors.grey300,
    }),
    pickerLabelStyle: {
      fontSize: 16,
      lineHeight: 24,
      color: colors.primaryTextColor,
      ...typography.interRegular,
    },
    flatListStyle: {
      position: 'absolute',
      top: 50,
      width: 248,
      maxHeight: 192,
      backgroundColor: colors.white,
      borderWidth: 1,
      borderColor: colors.grey300,
      borderRadius: 8,
    },
  };
};
